/**
  * Global service store for re-use of services
  */
export var WMJSServiceStore = [];
export var WMJSServiceStoreXML2JSONRequest = {
  proxy: 'Check WMJSGlobals WMJSServiceStoreXML2JSONRequest'
};
